import {BaseService} from './baseService.js';
import {Service} from './service.js';

/* 
 * Handles interaction with the feature switch
 */
export class FeatureSwitchService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getSwitches(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var data = await this.makeGETRequest('/api/resource/feature-switches' + params);		
		return data;
	}
	
	async setSwitchState(newState) {		
		var saved = this.makePOSTRequest('/api/resource/feature-switches', newState);	
		return saved;
	}	
	
}

